import React, { useEffect } from 'react';
import styles from './login.module.css';
import login from '../../assets/SVG/SpinnerWithSpermAndLines.png';
import logo from '../../assets/SVG/VIDAI_NEW_LOGO.svg';
import LoginFormComponent from '../../components/loginFormComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import MultilingualDropdown from '../../utils/multilingual';
import { Trans, useTranslation } from 'react-i18next';

export const RedirectLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const access = params.get('access');

    if (access) {
      localStorage.setItem('token', access);
      navigate('/admin/appointments');
    }
    else {
      navigate('/login');
    }
  }, [location, navigate]);
  return null;
};
export default function Login() {
  const { i18n, t } = useTranslation('login');
  useEffect(() => {
    const storedLang = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(storedLang);
  }, [i18n]);

  return (
    <div className={styles.login}>
      <div className={styles.langSelector}>
        <MultilingualDropdown />
      </div>
      <div className={styles.banner}>
        <img src={login} alt='login' />
        <div className={styles.bannertext}>
          <Trans
            i18nKey="banner"
            ns="login"
            components={[<span key="ai" className={styles.AIPowerCss} />]}
            values={{ ai: t('ai') }}
          />
        </div>
      </div>
      <div className={styles.panel}>
        <div className={styles.logo}>
          <img src={logo} alt='login' />
        </div>
        <div className={styles.form}>
          <LoginFormComponent successroute='/dashboard' />
        </div>
      </div>
    </div>
  );
}